export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <span>© {year} VietSurvive</span>
    </footer>
  );
}
